import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Layout from '../components/RecoverUsername';

class RecoverUsername extends Component {
  constructor() {
    super();
    this.state = { error: null, success: null, loading: false };
  }

  /**
   * On Form Submission
   */
  onFormSubmit = async (data) => {
    const { recoverUsername } = this.props;
    this.setState({ success: null, error: null, loading: true, message: null });

    try {
      const { success, message } = await recoverUsername(data);
      this.setState({ success, error: !success, loading: false, message });
    } catch (error) {
      this.setState({ loading: false, success: null, error: true, message: error.message });
    }
  };

  /**
   * Render
   */
  render = () => {
    const { userInput } = this.props;
    const { error, loading, success, message } = this.state;

    return (
      <Layout
        error={error}
        loading={loading}
        success={success}
        message={message}
        defaultValues={userInput}
        onFormSubmit={this.onFormSubmit}
      />
    );
  };
}

RecoverUsername.propTypes = {
  userInput: PropTypes.shape({}).isRequired,
  recoverUsername: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  userInput: state.articles.userInput || {},
});

const mapDispatchToProps = (dispatch) => ({
  recoverUsername: dispatch.member.recoverUsername,
});

export default connect(mapStateToProps, mapDispatchToProps)(RecoverUsername);
